import { React, PT, fetchApi } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Modal, Button, Dimmer, Loader, Grid, Table, Popup, List } from 'semantic-ui-react';

function popupJson(v) {
  return (
    <Popup
      on="click"
      position="left center"
      wide="very"
      style={{ maxHeight: 600, overflow: 'scroll' }}
      trigger={(
        <span>click for detail</span>
      )}
      content={
        (
          <JSONTree
            data={v}
            hideRoot
            shouldExpandNode={() => true}
          />
        )
      }
    />
  );
}

function GUOfferComponent({ offer, error }) {
  const { offerState: {
    status: offerStatus,
    earnings: [{ // assuming earning will only have 1 element
      componentState: { statusDetailCodes = [] } = {},
      amountEarned: { amount: amountEarned, currency } = {},
      earningsBreakdown: { breakdown: earningsBreakdown = [] } = {},
    }] = [{}],
  } } = offer;
  return (
    <Table definition>
      <caption>Data from GetUpside</caption>
      {offer && Object.keys(offer).length > 0
        ? (
          <Table.Body>
            <Table.Row>
              <Table.Cell>State</Table.Cell>
              <Table.Cell textAlign="right">
                { offerStatus }
                &nbsp;[
                { statusDetailCodes.join(', ') }
                ]
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Amount earned</Table.Cell>
              <Table.Cell textAlign="right">
                { amountEarned }
                &nbsp;
                { currency }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Breakdown</Table.Cell>
              <Table.Cell textAlign="right">
                <List>
                  {
                    earningsBreakdown.length
                      ? earningsBreakdown.map(b => (
                        <List.Item key={b.id}>
                          <span style={{ fontWeight: 'bold' }}>
                            {b.label}
                          </span>
                          : &nbsp;
                          {b.text}
                        </List.Item>
                      ))
                      : null
                  }
                </List>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Offer</Table.Cell>
              <Table.Cell textAlign="right">{popupJson(offer)}</Table.Cell>
            </Table.Row>
          </Table.Body>
        )
        : (
          <Table.Body>
            <Table.Row>
              <Table.Cell>Error</Table.Cell>
              <Table.Cell textAlign="right">{popupJson(error)}</Table.Cell>
            </Table.Row>
          </Table.Body>
        )}
    </Table>
  );
}

GUOfferComponent.propTypes = {
  offer: PT.shape(),
  error: PT.shape(),
};

GUOfferComponent.defaultProps = {
  offer: {},
  error: {},
};

export class GUTransactionCorrectionModal extends React.Component {
  state = {}

  loadAndGo = (e) => {
    const { accountId, coupon: { lookup_code: offerId } } = this.props;
    e.stopPropagation();
    this.setState({ opened: true, loading: true }, async () => {
      const { body: GUOffer, status, error } = await fetchApi({
        url: `/loyalty/offers/getupside/${accountId}/${offerId}`,
        method: 'GET',
        catchErrors: true,
      });
      if (error || status !== 200) {
        this.setState({ error, loading: false });
      } else {
        this.setState({ GUOffer, loading: false });
      }
    });
  }

  resyncOffer = (offer) => {
    this.setState({ loading: true }, async () => {
      let errorMsg = null;
      const { body, status } = await fetchApi({
        url: '/loyalty/offers/getupside/reprocess',
        catchErrors: true,
        body: offer,
      });
      if (status !== 200) {
        errorMsg = `Status: ${status}`;
      }
      this.setState({
        loading: false,
        processed: body.queued,
        errorMsg,
      });
    });
  }

  resyncBtn = (offer) => {
    const { processed, errorMsg } = this.state;
    const { earnings: [{ amountEarned }] = [{}] } = offer.offerState;
    if (amountEarned && amountEarned.amount) {
      if (processed) {
        return 'Queued! Might take a couple of minutes to update';
      }
      return (
        <div>
          <Button basic onClick={() => this.resyncOffer(offer)}>
            ReSync
          </Button>
          <span>{errorMsg}</span>
        </div>
      );
    }
    return null;
  }

  render() {
    const { opened, loading, GUOffer, error } = this.state;
    const { coupon: { lookup_code: offerId = 'Offer Id missing' } } = this.props;
    return (
      <Modal
        size="large"
        open={opened}
        trigger={<Button style={{ padding: 4 }} floated="right" size="mini" onClick={this.loadAndGo}>GU</Button>}
      >
        <Modal.Header>
          Offer id:&nbsp;
          {offerId}
        </Modal.Header>
        <Modal.Content>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <Grid padded>
              <Grid.Column>
                {GUOffer && GUOffer.offerState
                  ? (
                    <div>
                      <GUOfferComponent offer={GUOffer} error={error} />
                      {this.resyncBtn(GUOffer)}
                    </div>
                  )
                  : null
                }
              </Grid.Column>
            </Grid>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={() => this.setState({ opened: false, GUOffer: null })}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

GUTransactionCorrectionModal.propTypes = {
  accountId: PT.number,
  coupon: PT.shape({
    account_coupon_id: PT.number,
    coupon_id: PT.number,
    usage_limit: PT.number,
    begins_at: PT.string,
    expires_at: PT.string,
    transaction_ids: PT.arrayOf(PT.number),
    lookup_code: PT.string,
    eligibility: PT.object,
    name: PT.string,
    discount_type: PT.string,
    amount: PT.string,
  }),
};

GUTransactionCorrectionModal.defaultProps = {
  accountId: 0,
  coupon: {},
};
